"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISecretFrozen = exports.ISecretInactive = exports.ISecretLocked = exports.ISecretType = void 0;
var ISecretType;
(function (ISecretType) {
    ISecretType["BASE_DERIVATION_KEY_BASEKEY"] = "baseKey";
    ISecretType["_SFTP"] = "sftp";
    ISecretType["_PUBLICKEY"] = "publicKey";
    ISecretType["_PRIVATEKEY"] = "privateKey";
    ISecretType["_ECPRIVATEKEY"] = "ecPrivateKey";
    ISecretType["_APIKEY"] = "apikey";
})(ISecretType = exports.ISecretType || (exports.ISecretType = {}));
var ISecretLocked;
(function (ISecretLocked) {
    ISecretLocked[ISecretLocked["NOT_LOCKED_0"] = 0] = "NOT_LOCKED_0";
    ISecretLocked[ISecretLocked["LOCKED_1"] = 1] = "LOCKED_1";
})(ISecretLocked = exports.ISecretLocked || (exports.ISecretLocked = {}));
var ISecretInactive;
(function (ISecretInactive) {
    ISecretInactive[ISecretInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    ISecretInactive[ISecretInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(ISecretInactive = exports.ISecretInactive || (exports.ISecretInactive = {}));
var ISecretFrozen;
(function (ISecretFrozen) {
    ISecretFrozen[ISecretFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    ISecretFrozen[ISecretFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(ISecretFrozen = exports.ISecretFrozen || (exports.ISecretFrozen = {}));
